import styled from 'styled-components';
import { colors } from '../../const/color';
import { form as s } from '../../const/form-element';
import { FormInputStyled } from '../form/input';
import { InputGroupProps } from './types';

export const InputGroupAddonStyled = styled.div`
  min-width: 30px;
  display: flex;
  border: 1px solid ${colors.grayMedium};
  line-height: 20px;
  align-items: center;
  justify-content: center;
  border-right: none;
  box-sizing: border-box;
  & ~ div ${FormInputStyled} {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
  }
`;
export const InputGroupBlockStyled = styled.div`
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
  & ~ div ${InputGroupAddonStyled} {
    border-left: none;
    border-right: 1px solid ${colors.grayMedium};
    margin-left: -1px;
    button {
      margin: -1px -1px -1px 0;
    }
  }
`;
export const InputGroupStyled = styled.div<InputGroupProps>`
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  ${FormInputStyled} {
    width: 100%;
    line-height: 5px;
    display: block;
    font-size: 12px;
    box-sizing: border-box;
    background-color: ${colors.white};
    border: 1px solid ${colors.grayMedium};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ${InputGroupAddonStyled} {
    border-top-left-radius: ${({ $size }) => s.input[$size].radius}px;
    border-bottom-left-radius: ${({ $size }) => s.input[$size].radius}px;
  }
  ${InputGroupBlockStyled} ~ ${InputGroupAddonStyled} {
    border-right: 1px solid ${colors.grayMedium};
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: ${({ $size }) => s.input[$size].radius}px;
    border-bottom-right-radius: ${({ $size }) => s.input[$size].radius}px;
  }
`;
